// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/views/ManagementDDLjdbc2/styles.css
// module id = 2459
// module chunks = 193